import React from 'react';
import './TeensPriceCard.css'; 
import OrangeGradientButton from '../ui/OrangeGradientButton/OrangeGradientButton';
import LeftElement from '../../assets/elements/leftorange.png'; // Import your SVG
import RightElement from '../../assets/elements/rightorange.png'; // Import your SVG

interface TeensPriceCardProps {
  title: string;
  description: string;
  price: number;
  buttonText: string;
  subtext?: string;
  onButtonClick: () => void;
}

const TeensPriceCard: React.FC<TeensPriceCardProps> = ({
  title,
  description,
  price,
  buttonText,
  subtext,
  onButtonClick,
}) => {
  return (
    <div className="package-price-card-wrapper">
      {/* Left SVG Element */}
      <img src={LeftElement} alt="Decorative Left Element" className="svg-element left" />

      {/* Main Card */}
      <div className="teens-price-card">
        <h2 className="package-title">{title}</h2>
        <p className="package-description">{description}</p>
        <div className="package-price">
          <span className="price-amount"> 2,800 AED</span> 
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}> <OrangeGradientButton   onClick={onButtonClick}>{buttonText}</OrangeGradientButton></div>
       
        {subtext && <p className="package-subtext">{subtext}</p>}
      </div>

      {/* Right SVG Element */}
      <img src={RightElement} alt="Decorative Right Element" className="svg-element right" />
    </div>
  );
};

export default TeensPriceCard;
